import _ from 'lodash';

import './sidebar.scss';

/* @ngInject */
export default class SidebarController {
    constructor($scope, UiDisplayFactory, SidebarFactory, $state, PermissionsFactory, $rootScope, UserData) {
        this.$state = $state;
        this.UiDisplayFactory = UiDisplayFactory;
        this.SidebarFactory = SidebarFactory;
        this.PermissionsFactory = PermissionsFactory;

        this.navItems = [];
        this.prevNavItems = [];
        this.toggleSidebar = null;
        this.showReports = false;
        this.init();

        $scope.$on('UpdateDisplay', () => {
            const rules = this.UiDisplayFactory.getDisplayRules();
            if (rules.showFullSidebar !== this.toggleSidebar) {
                this.navItems = [];
                _.delay(() => {
                    const sidebarItems = _.map(this.SidebarFactory.getSidebar(), _.clone);
                    _.each(sidebarItems, (item) => {
                        this.configureSidebarItem(item, rules);
                        if (item.pageName.toLowerCase() === 'benji') {
                            item.isEnabled = rules.isBenjiUser;
                        }
                        if (item.isEnabled) {
                            this.navItems.push(item);
                        }
                    });
                    this.toggleSidebar = rules.showFullSidebar;
                    this.prevNavItems = angular.copy(this.navItems);

                    /* Remove this code to enable OH product lookup */
                    UserData.getUserLocations().then((response) => {
                        if (response.every(item => item.State === 'OH')) {
                            this.removeProductLookUpFromMenu();
                        }
                    });
                });
            }
        });

        /* Remove this code to enable OH product lookup */
        $rootScope.$on('HPLocationChange', (event, data) => {
            if (data.State === 'OH') {
                this.removeProductLookUpFromMenu();
            } else {
                this.navItems = this.prevNavItems;
            }
        });
    }

    /* Remove this code to enable OH product lookup */
    removeProductLookUpFromMenu() {
        this.navItems = this.navItems.filter(item => item.pageName !== 'product-lookup');
    }

    isPageActive(viewLocation) {
        return viewLocation === this.$state.current.name;
    }

    // private functions

    init() {
        if (this.PermissionsFactory.hasPermission('LeadSummary.LinkEnabled')) {
            this.UiDisplayFactory.setDisplayRule('showReports', true);
            this.showReports = this.UiDisplayFactory.getDisplayRules().showReports;
        }
    }

    configureSidebarItem(item, rules) {
        _.each(rules, (rule, key) => {
            if (item.displayFlag === key) {
                item.isEnabled = rule;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/common/sidebar/sidebarController.js